import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, resolveComponent as _resolveComponent, vShow as _vShow, withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx } from "vue"

import { getCurrentInstance, onMounted, ref } from 'vue';
import Global from '@/ts/Global';
import { useRoute } from 'vue-router';
import GuideControlComponent from '@/components/Templates/Controls/GuideControlComponent.vue';
import LoadingComponent from './components/LoadingComponent.vue';

import Tools from './ts/Tools';
import { ColorEnum } from './ts/SuperEnum';
import { ConfigProviderTheme } from 'vant';
import TTSPlayer from './ts/TTSPlayer';
import VoiceModelVO from './ts/vo/edgetts/VoiceModelVO';
import GuideMenuButtonVO from './ts/vo/GuideMenuButtonVO';


export default /*@__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props, { expose: __expose }) {

const theme = ref<ConfigProviderTheme>('dark');
const isInit = ref(false); //是否已经初始化完毕
const LoadingRef = ref<InstanceType<typeof LoadingComponent>>();
const guideControlRef = ref<InstanceType<typeof GuideControlComponent>>();
const route = useRoute();

const ToBack = () => {
  history.back();
};


onMounted(async () => {
  let _this = getCurrentInstance();
  if (_this) {
    Global.app = _this.exposed as any;
    isInit.value = true;
    Global.TryToLoginAsync();
  }
});

__expose({
  LoadingRef,
  guideControlRef
})


return (_ctx: any,_cache: any) => {
  const _component_VanNavBar = _resolveComponent("VanNavBar")!
  const _component_router_view = _resolveComponent("router-view")!
  const _component_van_config_provider = _resolveComponent("van-config-provider")!

  return (_openBlock(), _createBlock(_component_van_config_provider, {
    theme: theme.value,
    class: "app-main"
  }, {
    default: _withCtx(() => [
      _createVNode(LoadingComponent, {
        ref_key: "LoadingRef",
        ref: LoadingRef
      }, null, 512),
      _createVNode(GuideControlComponent, {
        ref_key: "guideControlRef",
        ref: guideControlRef
      }, null, 512),
      _withDirectives(_createVNode(_component_VanNavBar, {
        class: "top-menus",
        onClickLeft: ToBack,
        "left-arrow": "",
        title: ((_unref(route).meta?.Title ?? '未命名' + _unref(route).meta?.HideNavbar) as any)
      }, null, 8, ["title"]), [
        [_vShow, _unref(route).meta?.HideNavbar == false]
      ]),
      (isInit.value)
        ? (_openBlock(), _createBlock(_component_router_view, { key: 0 }))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }, 8, ["theme"]))
}
}

})